import { ClientLayout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'

const { t } = useI18n()

export const ClientRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: ClientLayout,
    redirect: '/client/navigation',
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/redirect',
    component: ClientLayout,
    name: 'Redirect',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect1',
        component: () => import('@/views/Common/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Common/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/games',
    component: ClientLayout,
    name: 'Games',
    meta: {
      title: '游戏目录'
    },
    children: [
      {
        path: '',
        component: () => import('@/views/Games/index.vue'),
        name: 'GamesIndex',
        meta: {
          title: '游戏目录'
        }
      },
      {
        path: 'running-parkour',
        component: () => import('@/views/Games/RunningParkour/index.vue'),
        name: 'GamesRunningParkour',
        meta: {
          title: '人体跑酷'
        }
      }
    ]
  },
  {
    path: '/client',
    component: ClientLayout,
    redirect: '/client/navigation',
    name: 'Client',
    meta: {
      title: '客户端',
      hidden: true
    },
    children: [
      {
        path: 'navigation',
        component: () => import('@/views/Client/Navigation/index.vue'),
        name: 'ClientNavigation',
        meta: {
          title: '导航网站',
          icon: 'vi-ant-design:dashboard-filled'
        }
      },
      {
        path: 'navigation/type/:code',
        component: () => import('@/views/Client/Navigation/TypeMore.vue'),
        name: 'ClientNavigationTypeMore',
        meta: {
          title: '导航类型更多',
          hidden: true
        }
      },
      {
        path: 'content',
        component: () => import('@/views/Client/Content/index.vue'),
        name: 'ClientContentCenter',
        meta: {
          title: t('router.contentCenter'),
          hidden: true
        }
      },
      {
        path: 'content/detail/:publicCode',
        component: () => import('@/views/Client/Content/Detail.vue'),
        name: 'ClientContentDetail',
        meta: {
          title: t('router.contentDetail'),
          hidden: true
        }
      },
      {
        path: 'media/video',
        component: () => import('@/views/Client/Media/Video/index.vue'),
        name: 'MediaVideoIndex',
        meta: {
          title: '视频首页'
        }
      },
      {
        path: 'media/video/detail/:mediaCode',
        component: () => import('@/views/Client/Media/Video/Detail.vue'),
        name: 'MediaVideoDetail',
        meta: {
          title: '视频详情'
        }
      },
      {
        path: 'media/video/search',
        component: () => import('@/views/Client/Media/Video/Search.vue'),
        name: 'MediaVideoSearch',
        meta: {
          title: '视频搜索'
        }
      },
      {
        path: 'personal',
        component: () => import('@/views/Client/Personal/index.vue'),
        name: 'ClientPersonal',
        meta: {
          title: '个人中心',
          icon: 'vi-ant-design:user-outlined',
          hidden: true,
          canTo: true
        }
      },
      {
        path: 'api-key',
        component: () => import('@/views/Client/Auth/Apikey/index.vue'),
        name: 'ClientApikey',
        meta: {
          title: 'api-key',
          icon: 'vi-ant-design:user-outlined',
          hidden: true,
          canTo: true
        }
      },
      {
        path: 'tenant-select',
        component: () => import('@/views/Client/TenantSelect/index.vue'),
        name: 'ClientTenantSelect',
        meta: {
          title: t('tenant.select'),
          hidden: true,
          canTo: true
        }
      }
    ]
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  }
]
